/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RegionPrefecture,
    RegionPrefectureFromJSON,
    RegionPrefectureFromJSONTyped,
    RegionPrefectureToJSON,
} from './RegionPrefecture';

/**
 * 
 * @export
 * @interface Region
 */
export interface Region {
    /**
     * エリアのID。media_region_jp_idに相当
     * @type {number}
     * @memberof Region
     */
    regionId: number;
    /**
     * エリア名
     * @type {string}
     * @memberof Region
     */
    regionName: string;
    /**
     * 内包されている都道府県
     * @type {Array<RegionPrefecture>}
     * @memberof Region
     */
    prefectures: Array<RegionPrefecture>;
}

export function RegionFromJSON(json: any): Region {
    return RegionFromJSONTyped(json, false);
}

export function RegionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Region {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'regionId': json['region_id'],
        'regionName': json['region_name'],
        'prefectures': ((json['prefectures'] as Array<any>).map(RegionPrefectureFromJSON)),
    };
}

export function RegionToJSON(value?: Region | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'region_id': value.regionId,
        'region_name': value.regionName,
        'prefectures': ((value.prefectures as Array<any>).map(RegionPrefectureToJSON)),
    };
}

